import { createContext } from "react";

import type { AgentSdk } from "./agentSdk";

export const AgentSdkContext = createContext<AgentSdk | undefined>(undefined);
